export default function useProjectStatus({
  start,
  end,
}: {
  start?: string | Date
  end?: string | Date
}) {
  const isComingSoon = !start || (start && new Date(start) > new Date())
  const hasEnded = end && new Date(end) < new Date()
  return isComingSoon ? 'coming-soon' : hasEnded ? 'ended' : 'active'
}
